import Spinner, { DarkBlueSpinner, GreenSpinner, WhiteSpinner } from '~/components/Spinner/Spinner';

export default Spinner;
export { GreenSpinner, WhiteSpinner, DarkBlueSpinner };
